import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import Link from 'next/link';
import { companyNameQuery } from '../../queries';
import useBugsnagNotifier from '../../hooks/useBugsnagNotifier';
import Profile from '../../public/static/images/tab_bar/cabinet.svg';
import Icon from '../Icon';
import { TabBarLink, TabBarIconWrapper, TabBarLinkText } from './styled';
import { useClient } from '../../hooks/useClient';

interface TabBarItemAuthProps {
  onClick: () => void;
  children: React.ReactNode;
  isActive?: boolean;
  path: string;
}

export const TabBarItemAuth: FC<TabBarItemAuthProps> = ({
  onClick,
  children,
  isActive
}) => {
  const isClient = useClient();
  const { t } = useTranslation();
  const { data, error } = useQuery(companyNameQuery, {
    ssr: false,
    skip: !isClient
  });

  const profile = useMemo(() => data?.profile || {}, [data]);
  const phoneOrName = profile.phone || profile.name;

  useBugsnagNotifier(error);

  return phoneOrName ? (
    <Link
      href="/profile"
      data-cy="profile-link"
      data-stat="tab-bar-profile-link"
      style={{ textDecoration: 'none' }}
    >
      <TabBarLink as="div" $active={isActive}>
        <TabBarIconWrapper>
          <Icon
            indent={false}
            width={20}
            height={20}
            color={isActive ? 'dark' : 'brown'}
            IconComponent={Profile}
          />
        </TabBarIconWrapper>
        <TabBarLinkText $active={isActive}>
          {t('tab_bar.buttons.cabinet')}
        </TabBarLinkText>
      </TabBarLink>
    </Link>
  ) : (
    <TabBarLink
      role="button"
      onKeyPress={onClick}
      onClick={onClick}
      tabIndex={0}
      data-cy="login-button"
      data-stat="tab-bar-login-link"
    >
      {children}
    </TabBarLink>
  );
};
